<template>
  <div class="drugSafeRemianConfig">
    <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-width="90px">
      <el-form-item label="名称" label-width="40px">
        <el-input style="width: 140px" @input="search" clearable v-model="searchForm.name" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="编码">
        <el-input style="width: 140px" @input="search" clearable v-model="searchForm.code" placeholder="请输入"></el-input>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 20px">
      <el-button type="primary" @click="search">查询<i class="el-icon-search el-icon--right"></i></el-button>
      <el-button type="info" @click="clear">重置<i class="el-icon-refresh-right el-icon--right"></i></el-button>
      <el-button type="warning" @click="addItem">新增<i class="el-icon-plus el-icon--right"></i></el-button>
    </div>
    <div style="border: 1px solid #c9cdd6">
      <el-table
          :header-cell-style="{background:'#F5F5F5'}"
          :data="tableData"
          max-height="600"
          style="width: 100%"
      >
        <el-table-column
            prop="id"
            label="序号">
        </el-table-column>
        <el-table-column
            prop="drugCode"
            label="药品编码">
        </el-table-column>
        <el-table-column
            prop="remainAmount"
            label="安全存量">
        </el-table-column>
        <el-table-column
            prop="unit"
            label="单位">
        </el-table-column>
        <el-table-column
            prop="address"
            fixed="right"
            width="150"
            align="center"
            label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="editorClick(scope.row)">编辑</el-button>
            <el-button type="text" size="medium" @click="deleteClick(scope.row.id)">删除</el-button>
            <!--            <el-button type="text" size="medium" @click="lockClick(scope.row.id)">锁定</el-button>-->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div style="margin-top: 20px">
      <Pagination :total='total' :currentPage='currPage' :pageSize='pageSize' @handleSizeChange='handleSizeChange'
                  @handleCurrentChange='handleCurrentChange'></Pagination>
    </div>
    <el-dialog
        :title="modelTitle"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
        width="20%">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="90px"  class="demo-ruleForm">
        <el-form-item label="药品编码">
          <el-input v-model="ruleForm.drugCode" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="安全存量">
          <el-input v-model="ruleForm.remainAmount" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="药房">
          <DicInput  style="width: 100%" @fieldId="fieldId($event,'pharmacyId')" :dicType="8"></DicInput>
        </el-form-item>
        <el-form-item label="单位">
          <el-input v-model="ruleForm.unit" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
          <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import DicInput from "@/components/DicInput";

export default {
  name: "drugSafeRemianConfig",
  data() {
    return {
      tableData: [],
      searchForm: {
        name: '',
        code: '',
      },
      modelTitle: '新增药品消耗',
      dialogVisible: false,
      ruleForm: {
        drugCode: '',
        remainAmount:null
      },
      rules: {
      },
      areaId: '',
      total: 0, //总条数
      currPage: 1,//当前页码
      pageSize: 10, //每页条数
    }
  },
  components: {
    //someComponent
    Pagination,
    DicInput
  },
  methods: {
    //搜索
    search() {
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    clear() {
      this.searchForm = {
        code: '',
        parentCode: ''
      }
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    fieldId(item,name){ // 字典
      if(item.id){
        this.ruleForm[name]=item.id
        this.ruleForm.pharmacyCode=item.code
      }else {
        this.searchForm[name]=''
      }
    },
    addItem() {
      this.modelTitle = '新增药品消耗'
      this.ruleForm = {
        drugCode: '',
      }
      this.dialogVisible = true
    },
    editorClick(row) {
      this.modelTitle = '编辑药品消耗'
      this.areaId = row.id
      this.ruleForm = {
        ...row
      }
      this.dialogVisible = true
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            ...this.ruleForm,
            remainAmount: Number(this.ruleForm.remainAmount)
          }
          if (this.modelTitle === '编辑药品消耗') {
            this.axios
                .put("api/DrugSafeRemianConfig?id=" + this.areaId, data).then((res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.$refs[formName].resetFields();
              this.dialogVisible=false
              this.init()
            })
          } else {
            this.axios
                 .post("api/DrugSafeRemianConfig", data).then((res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.$refs[formName].resetFields();
              this.dialogVisible=false
              this.init()
            })
          }
        } else {
          return false;
        }
      });
    },
    deleteClick(id) { //删除
      let data = {
        id: id
      }
      this.axios
           .delete("api/DrugSafeRemianConfig", {params:data}).then((res) => {
        this.$message({
          message: '删除成功',
          type: 'success'
        });
      }).finally(error=>{
        this.init()
      })
    },
    lockClick(id){
      let data = {
        id: id
      }
      this.axios
           .delete("api/DrugSafeRemianConfig/Lock?id="+flag.id, {params:data}).then((res) => {
        this.$message({
          message: '锁定成功',
          type: 'success'
        });
      }).finally(error=>{
        this.init()
      })
    },
    // ----------分页控制-------------
    handleSizeChange(val) {
      this.pageSize = val
      this.init()
    },
    handleCurrentChange(val) {
      this.currPage = val
      this.init()
    },

    // list
    init() {
      let data = {
        name: this.searchForm.name,
        code: this.searchForm.code,
        page: this.currPage,
        pageSize: this.pageSize,
      }
      this.axios
          .get("api/DrugSafeRemianConfig", {params: data})
          .then((res) => {
            this.tableData = res.list
            this.total = res.count
          })
    }
  },
  mounted() {
    //
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.drugSafeRemianConfig {

}
</style>